import React, { Ref, forwardRef } from 'react';
import classnames from 'classnames';
import {
  ModalHeaderCloseButton,
  ModalHeaderCloseButtonProps,
} from '../modal/modal-header-close-button';

export type DialogHeaderCloseButtonProps = ModalHeaderCloseButtonProps;

export const DialogHeaderCloseButton = forwardRef(
  (
    { className, ...props }: DialogHeaderCloseButtonProps,
    ref: Ref<HTMLButtonElement>
  ): React.ReactElement => {
    const classNames = classnames(className, 'airtame-dialog__header-close-button');

    return <ModalHeaderCloseButton ref={ref} {...props} className={classNames} />;
  }
);
DialogHeaderCloseButton.displayName = 'DialogHeaderCloseButton';
